<div class="container d-flex justify-content-center">
    <div class="d-flex flex-column mt-4 form-wrapper">
        <h1 mat-dialog-title>Reset your password</h1>

        <!-- Success message -->
        <div mat-dialog-content *ngIf="resetPasswordEmailSent">
            <div>
                <p>We have sent you an email with reset instructions.</p>
            </div>
        </div>

        <!-- Reset password form -->
        <div mat-dialog-content *ngIf="!resetPasswordEmailSent">
            <div>
                <p>
                    Please provide your account email where you will receive
                    further instructions on how to reset your password.
                </p>
            </div>
            <mat-form-field appearance="fill" class="w-100">
                <input
                    matInput
                    placeholder="Email"
                    name="email"
                    type="email"
                    required
                    [formControl]="email"
                />
                <mat-error *ngIf="email.invalid && email.hasError('required')"
                    >Please enter your email address.</mat-error
                >
                <mat-error *ngIf="email.invalid && email.hasError('email')"
                    >Please enter a valid email address.</mat-error
                >
            </mat-form-field>

            <!-- Error returned from Firebase.auth -->
            <div
                *ngIf="firebaseAuthErrorMessage"
                class="form-error-row d-flex align-items-center mb-3"
            >
                <span>{{ firebaseAuthErrorMessage }}</span>
            </div>
        </div>

        <div mat-dialog-actions>
            <button mat-button (click)="closeDialog()">Close</button>
            <button
                mat-raised-button
                color="primary"
                type="submit"
                *ngIf="!resetPasswordEmailSent"
                (click)="sendResetPasswordEmail()"
            >
                Reset password
            </button>
        </div>
    </div>
</div>
